// ChatBotWidget.js
import React, { useState, useEffect } from 'react';
import ChatBot from 'react-chatbotify';
import banner22 from "../assets/images/slider01.png";
import ecoclub from "../assets/images/Logo-2.png";
import prak from '../assets/images/prakarti-img.png';
// Define your Eco Clubs FAQ data
const faqData = {
    "General Information": [
      {
        question: "What is the Eco Clubs for Mission LiFE Portal?",
        answer: "The portal is a digital platform to facilitate environmental awareness, action, and reporting by schools under the Mission LiFE (Lifestyle for Environment) initiative. For more details, visit https://ecoclubs.education.gov.in/api/2/"
      },
      {
        question: "Who can access the portal?",
        answer: "UDISE Registered schools and faculty members across India can access the portal."
      },
      {
        question: "What is the purpose of the portal?",
        answer: "To promote sustainable environmental practices in schools through Eco Club for Mission Life activities and help track and report impact."
      },
      {
        question: "Is the portal accessible to the public?",
        answer: "Only schools and authorized faculty can access the portal with valid credentials (OTP received over UDISE registered email and phone number)."
      },
      {
        question: "What kind of activities can be recorded on the portal?",
        answer: "Schools can report awareness sessions, plantation drives, energy-saving campaigns, and other green initiatives. There are a total of 7 Eco Clubs for Mission Life themes and their respective subthemes."
      }
    ],
    "Registration & Login": [
      {

        



        question: "How do schools register on the portal?",
        answer: "Schools are pre-registered using UDISE codes and receive login credentials via email and SMS."
      },
      {
        question: "What if a school has not received login credentials?",
        answer: "Schools should contact the support team with their UDISE code for any login queries:\ncontact.ecoclubs-edu@gov.in\ninfo.ecoclubs-edu@gov.in\nhelp.ecoclubs-edu@gov.in"
      },
      {
        question: "Can multiple teachers from one school access the portal?",
        answer: "Yes, schools can assign faculty to manage events, upload evidence, and track participation."
      }
    ],
    "Events & Activities": [
      {
        question: "How do I create a new event?",
        answer: "Click on the “Create Event” button, fill in the activity details. Schools and faculty can upload photos/videos under event management and submit for approval."
      },
      {
        question: "Can I edit an event after submission?",
        answer: "Yes, but only before final approval by the School Principal."
      },
      {
        question: "Who approves the events submitted by schools?",
        answer: "Only School Principals can approve the events submitted."
      },
      {
        question: "How do I know if my event is approved?",
        answer: "The Event List displays the approval status, and notifications are sent via email."
      }
    ],
    "Technical & Functional Support": [
      {
        question: "I'm unable to upload media. What should I do?",
        answer: "Ensure file size is within the allowed limit and the format is supported. For example, geotagged photos (Max 5 images, 10MB each) and videos (Max 3 videos, 5MB each) are accepted."
      },
      {
        question: "How do I report a technical issue with the portal?",
        answer: "Send an email to:\ncontact.ecoclubs-edu@gov.in\ninfo.ecoclubs-edu@gov.in\nhelp.ecoclubs-edu@gov.in\nor call 011-29581423."
      },
      {
        question: "What browsers are supported for the portal?",
        answer: "Google Chrome, Mozilla Firefox, and Microsoft Edge (latest versions recommended)."
      },
      {
        question: "What should I do if the portal is slow or unresponsive?",
        answer: "Clear your cache, ensure a stable internet connection, or try using a different browser."
      }
    ],
    "Reporting & Evaluation": [
      {
        question: "How can schools track their progress?",
        answer: "The dashboard displays activity counts, impact statistics, and comparative insights."
      },
      {
        question: "How to view the events created and their status?",
        answer: "Under the Event List, events are organized by their approval status for easy viewing."
      }
    ]
  };

// Extract FAQ category headings
const categories = Object.keys(faqData);

// We'll use a closure variable for the selected category.
let selectedCategory = "";

// Define the conversation flow without any reference to a personal name.
const faqFlow = {
  start: {
    message: "Welcome to the Eco Clubs FAQ Bot for Mission LiFE Portal. Please select a category:",
    options: categories,
    path: "process_category"
  },
  process_category: {
    transition: {duration: 0},
    chatDisabled: true,
    path: async (params) => {
      selectedCategory = params.userInput;
      await params.injectMessage(`You selected "${params.userInput}".`);
      return "show_questions";
    }
  },
  show_questions: {
    message: "Please select a question:",
    options: () => faqData[selectedCategory].map(faq => faq.question),
    path: "process_question"
  },
  process_question: {
    transition: {duration: 0},
    chatDisabled: true,
    path: async (params) => {
      const selectedQuestion = params.userInput;
      const faqEntry = faqData[selectedCategory].find(faq => faq.question === selectedQuestion);
      if (faqEntry) {
        await params.injectMessage(faqEntry.answer);
      } else {
        await params.injectMessage("Sorry, I couldn't find the answer to that question.");
      }
      return "ask_another";
    }
  },
  ask_another: {
    message: "Would you like to see another question or go back to the categories?",
    options: ["Another Question", "Go to Categories"],
    path: "handle_another_choice"
  },
  handle_another_choice: {
    transition: {duration: 0},
    chatDisabled: true,
    path: async (params) => {
      if (params.userInput === "Another Question") {
        return "show_questions";
      } else {
        return "start";
      }
    }
  },
  unknown_input: {
    message: "I'm sorry, I didn't understand that. Please try again.",
    options: ["Another Question", "Go to Categories"],
    path: "handle_another_choice"
  }
};

// The ChatBotWidget component with an always-visible sticker and notification badge.
const ChatBotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  // A simple flag for notification; you could also use a count if needed.
  const [notification, setNotification] = useState(false);

  const toggleChat = () => {
    setIsOpen((prev) => !prev);
    if (!isOpen) {
      // When opening the chat, clear the notification badge.
      setNotification(false);
    }
  };

  // Simulate a new bot message (notification) when the chat is not open.
  useEffect(() => {
    let timer;
    if (!isOpen) {
      timer = setTimeout(() => {
        setNotification(true);
      }, 5000); // Simulated new message after 5 seconds
    }
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <>
      {/* Chat window (rendered only when open) */}
      {isOpen && (
        <div 
          style={{
            position: 'fixed',
            bottom: '80px',
            right: '20px',
            zIndex: 1000,
            width: '350px',
            maxHeight: '500px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            borderRadius: '8px',
            overflow: 'hidden',
            background: '#fff',
            
            paddingRight:0,
            paddingLeft:0,
          }}
        >
          <ChatBot 
            
            settings={{
                general: {
                    embedded: true,
                    showInputRow: false,  // Disables the chat input field
                    primaryColor:' #30963f ',
                    secondaryColor:' #30963f',
                  },
                chatHistory: { storageKey: "eco_clubs_faq_bot" },
                header: {
                  title: "Eco Clubs For Mission LiFE",  // This sets your header title to "Eco Clubs"
                  showAvatar: true,  // Set to true if you want to show an avatar alongside the title,
                  avatar:ecoclub, // Path to your avatar image
                },
                sensitiveInput:{
                    maskInTextArea:false
                },
                chatInput:{
                    disabled:true,
                    sendCheckboxOutput:false
                },
                notification: {
                    disabled: true   // Disables the bell (notification) icon
                  },
                  chatWindow: {
                    showMessagePrompt: true,
                    messagePromptText: "Type your message here..."
                  }
                
              }}
            flow={faqFlow}
          />
        </div>
      )}

      {/* Chat sticker button – always visible */}
      
      <div className='chatwith'
       
        onClick={toggleChat}
      >
        {isOpen ? <div style={{color:"#fff"}}>✕</div> : <> {!isOpen && <div className='chatwithme'>Need Help?</div>}<img height={50} src={prak} /></>}
       
        {/* Notification badge shown only when chat is closed and a notification is triggered */}
        {/* {!isOpen && notification && (
          <span 
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              width: '15px',
              height: '15px',
              borderRadius: '50%',
              background: 'red',
              color: '#fff',
              fontSize: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            !
          </span>
        )} */}
      </div>
    </>
  );
};

export default ChatBotWidget;
